import { Amplify } from 'aws-amplify';

const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID || 'us-east-1_PLACEHOLDER';
const USER_POOL_CLIENT_ID = process.env.REACT_APP_USER_POOL_CLIENT_ID || 'PLACEHOLDER';

// Amos-83 Request Portal (Architecture A, Richard CP0 2026-09-04): requesters live in a
// SEPARATE Cognito pool. The pool is chosen by path at boot — `/portal/*` configures the
// requester pool, every other path configures the staff pool exactly as before. A
// requester token is therefore never valid on the staff app or its API Gateway, and a
// staff token is never valid on the portal routes. Nothing off `/portal` changes.
const PORTAL_USER_POOL_ID = process.env.REACT_APP_PORTAL_USER_POOL_ID || '';
const PORTAL_USER_POOL_CLIENT_ID = process.env.REACT_APP_PORTAL_USER_POOL_CLIENT_ID || '';
const PORTAL_API_URL = process.env.REACT_APP_PORTAL_API_URL || '';

const IS_PORTAL =
  typeof window !== 'undefined' &&
  /^\/portal(\/|$)/.test(window.location.pathname) &&
  !!PORTAL_USER_POOL_ID &&
  !!PORTAL_USER_POOL_CLIENT_ID;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: IS_PORTAL ? PORTAL_USER_POOL_ID : USER_POOL_ID,
      userPoolClientId: IS_PORTAL ? PORTAL_USER_POOL_CLIENT_ID : USER_POOL_CLIENT_ID,
    },
  },
});

export { USER_POOL_ID, USER_POOL_CLIENT_ID, IS_PORTAL, PORTAL_API_URL, PORTAL_USER_POOL_ID, PORTAL_USER_POOL_CLIENT_ID };
